import { Audio } from 'react-loader-spinner'

export default function Spinner() {
  return (
    <div style={{ textAlign: 'center', padding: '10px'}}>
      <Audio color="#007BFF" wrapperStyle={{ display: 'block' }} />
    </div>
  )
}
